<template>
  <v-container fluid fill-height>
    <v-layout row wrap>
      <v-flex sm12>
        <v-toolbar
          color="#eee"
          class="elevation-0 secondary--text mb-4"
          style="background: transparent" >
          <v-toolbar-title>Minhas Redes</v-toolbar-title>

          <v-spacer></v-spacer>
          <v-btn icon color="primary" @click="dialogCadRede">
            <v-icon>add</v-icon>
          </v-btn>
        </v-toolbar>
        <v-data-table
          hide-actions
          :hide-headers="!redes.length"
          :pagination.sync="pagination"
          :items="redes"
          :headers="redesHeader"
          class="elevation-1"
        >
          <v-alert v-slot:no-results :value="true" color="error" icon="warning">
            Desculpe, não encontramos nenhum dado!
          </v-alert>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">{{props.item.nome}}</td>
              <td class="text-xs-center">{{props.item.matriz && (props.item.matriz.nome_fantasia)}}</td>
              <td class="text-xs-center">{{props.item.matriz && (props.item.matriz.cnpj)}}</td>
              <td class="text-xs-right">
                <v-tooltip bottom v-if="props.item.tipo_rede == 0">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" flat icon color="error" @click="deletarRede(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Deletar Rede</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" flat icon color="info" @click="editarRede(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar Rede</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" flat icon color="primary" @click="selecionarRede(props.item)">
                      <v-icon>remove_red_eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver Detalhes da Rede</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center">
          <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" width="600" :fullscreen="$vuetify.breakpoint.xs" persistent>
      <cad-rede
        v-if="dialog"
        :first="false"
        @success="snackbarSuccess"
        @fechar="dialog = false"
        @error="snackbarError"
      />
    </v-dialog>
    <v-dialog lazy width="600" v-model="dialogInfoRede" :fullscreen="$vuetify.breakpoint.xs">
      <info-rede v-if="dialogInfoRede" :rede="redeSelected" @fechar="dialogInfoRede = false"/>
    </v-dialog>
    <v-dialog lazy width="600" v-model="dialogEdit" :fullscreen="$vuetify.breakpoint.xs" persistent>
      <edit-rede
        v-if="dialogEdit"
        :rede="redeSelected"
        @fechar="dialogEdit = false"
        @success="snackbarSuccess"
        @error="snackbarError"
      />
    </v-dialog>
    <v-dialog lazy width="500" v-model="dialogDelete" :fullscreen="$vuetify.breakpoint.xs">
      <deletar-rede
        v-if="dialogDelete"
        :rede="redeSelected"
        @fechar="dialogDelete = false"
        @success="snackbarSuccess"
        @error="snackbarError"
      />
    </v-dialog>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import InfoRede from '@/components/dialogs/DialogInfoRede'
import CadRede from '@/components/cadastros/CadRede'
import EditRede from '@/components/dialogs/EditRede'
import DeletarRede from '@/components/dialogs/DeletarRede'

export default {
  components: { CadRede, InfoRede, EditRede, DeletarRede },
  data () {
    return {
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      },
      dialogInfoRede: false,
      redeSelected: null,
      pagination: {
        rowsPerPage: 10
      },
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      redesHeader: [
        {
          text: 'Nome',
          align: 'center',
          sortable: false
        },
        {
          text: 'Nome do posto matriz',
          align: 'center',
          sortable: false
        },
        {
          text: 'CNPJ do posto matriz',
          align: 'center',
          sortable: false
        },
        {
          align: 'right',
          sortable: false
        }
      ]
    }
  },
  computed: {
    redes () {
      return this.$store.getters.redes
    },
    postos () {
      return this.$store.getters.postos
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  mounted () {
    this.$store.dispatch('pegarRedes')
  },
  methods: {
    snackbarSuccess (text) {
      this.snackbar.color = 'info'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    snackbarError (text) {
      this.snackbar.color = 'error'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    editarRede (rede) {
      this.redeSelected = rede
      this.dialogEdit = true
    },
    deletarRede (rede) {
      this.redeSelected = rede
      this.dialogDelete = true
    },
    selecionarRede (rede) {
      this.redeSelected = rede
      this.dialogInfoRede = true
    },
    async dialogCadRede () {
      let tamanho
      await this.$store.dispatch('postosSemRede').then(value => {
        tamanho = value.length
      })
      if (tamanho > 0) {
        this.dialog = true
      } else {
        alert('A quantidade de postos sem rede é insuficiente para criar um nova rede.')
      }
    }
  }
}
</script>
